// Copyright (c) 2016 Deere & Company

import './dealer-search-modal.scss';
import React, {PropTypes} from 'react';
import DealerSearch from '../../dealer-search/state-connector';
import {FormattedMessage} from 'react-intl';
import {WarrantyMediumModal} from '../../../shared/components/modal';

const DealerSearchModal = props =>
    <section className='dealer-search-modal'>
        <WarrantyMediumModal isOpen={props.isOpen}>
            <header>
                <FormattedMessage id='CHANGE_RESPONSIBLE_DEALER'/>
                <span
                    className='close-modal-icon'
                    onClick={props.onClose}
                />
            </header>
            <div className='modal-body'>
                <DealerSearch/>
            </div>
        </WarrantyMediumModal>
    </section>;

DealerSearchModal.displayName = 'DealerSearchModal';
DealerSearchModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DealerSearchModal;



// WEBPACK FOOTER //
// ./src/product/new-transfer/components/dealer-search-modal.js